import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import './AddItemHeader.scss';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useHistory} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {isMobileAndTablet} from '../../helpers/common';

const AddItemHeader = ({branchInfo, t}) => {
  const history = useHistory();
  const isMobile = isMobileAndTablet();

  const onCloseClick = () => {
    history.goBack();
  };

  return (
    <div className={ `add-item-header ${isMobile ? 'mobile-header' : 'desktop-header'}` }>
      <div className="container ">
        <div className={ 'content' }>

          <div className={ 'back-btn' } onClick={ onCloseClick }>
            <div className={ 'back-icon' }>
              <FontAwesomeIcon icon={ 'chevron-left' } />
            </div>
            <div className={ 'back-text' }>
              {t('buttons.back')}
            </div>
          </div>

          <div
            className={ 'close-btn' }
            onClick={ onCloseClick }
          >
            <FontAwesomeIcon icon="times" />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    branchInfo
  } = state;

  return {
    branchInfo
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {},
    dispatch,
  );

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(AddItemHeader));
